import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Stakeholder } from "@/types";

export function useCreateAddJobStakeholder() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      stakeholderId,
      stakeholder,
    }: {
      stakeholderId: number;
      stakeholder?: Stakeholder;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/stakeholders`;
      const res = await guacHttpClient.post<
        Stakeholder,
        HttpResponse<Stakeholder>
      >(path, { stakeholderId });
      return stakeholder ?? res.data;
    },
    onSuccess: (fullStakeholder) => {
      queryClient.setQueryData(
        ["job-stakeholders", currentCompanyId, currentJobId],
        (cachedData?: Stakeholder[]) => {
          if (!cachedData) return [fullStakeholder];
          return [...cachedData, fullStakeholder];
        },
      );
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });

      void queryClient.invalidateQueries({
        queryKey: ["job-intake", currentCompanyId, currentJobId],
      });
    },
  });
}
